// ImageSlider.js
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const images = [
  {
    id: 1,
    header: 'Solar Potential Checker',
    thumbnail: './solarchecker.webp',
    content: 'A web-app that allows user customizations to check solar potential of a house.  Skills used: React, Google Places APIs, Redux Store',
    link: 'https://solarcheck.netlify.app/'
  },
  {
    id: 2,
    header: 'Playlist Creator',
    thumbnail: './spc.webp',
    content: 'Website connected with Spotify APIs to search for songs and add to a new playlist. Skills used: React, Rest APIs',
    link: 'https://manage-spotify.netlify.app/'
  },
  {
    id: 3,
    header: 'Reddit Explorer',
    thumbnail: './reddit-exp.webp',
    content: 'A website that fetches and displays posts from Reddit. Skills used: React, JSON parsing, Redux store',
    link: 'https://bestofreddit.netlify.app/'
  },
  {
    id: 4,
    header: 'Meal Planner',
    thumbnail: './mealsugesstor.webp',
    content: 'A quick tool that gives suggestions for each meal of the day. Skills used: React, JavaScript algos',
    link: 'https://mealplanner07.netlify.app/'
  },
];

const CodingProjects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const setScrollInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000); // Change image every 10 seconds
  };

  useEffect(() => {
    setScrollInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    resetScrollInterval();
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    resetScrollInterval();
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    resetScrollInterval();
  };

  const resetScrollInterval = () => {
    clearInterval(intervalRef.current);
    setScrollInterval();
  };

  return (
    <SliderContainer>
      {/* <p className='pmp-title'>Products I've worked on</p> */}
      <Dots>
        <ArrowLeft onClick={prevSlide}>&#x276E;</ArrowLeft>
        {images.map((_, index) => (
          <Dot key={index} active={currentIndex === index} onClick={() => goToSlide(index)} />
        ))}
        <ArrowRight onClick={nextSlide}>&#x276F;</ArrowRight>
      </Dots>
      <div className='ImageContainer'>
        <Image src={images[currentIndex].thumbnail} alt={`Slide ${currentIndex + 1}`} />
        <div className='pmp-content'>
          <p className='pmp-header'>{images[currentIndex].header}</p>
          <p className='pmp-type'>{images[currentIndex].type}</p>
          <p className='pmp-desc'>{images[currentIndex].content}</p>
          {images[currentIndex].newslink && <button className='pmp-button'><a className='pmp-link' href={images[currentIndex].newslink}>News Coverage</a></button>}
          {images[currentIndex].link && <button ><a className='pmp-link' href={images[currentIndex].link}>Product Link</a></button>}
        </div>
      </div>



    </SliderContainer>
  );
};

export default CodingProjects;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
`;

// const ImageContainer = styled.div`
//   position: relative;
//   display:flex;
// `;

const Image = styled.img`
  width: 50%;
  max-height:400px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.4);
  }
`;

const Dots = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const Dot = styled.span`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: ${(props) => (props.active ? '#094024' : '#bbb')};
  border-radius: 50%;
  cursor: pointer;
`;

const Arrow = styled.div`
  // position: absolute;
  // top: 2%;
  // transform: translateY(-50%);
  font-size: 1.5rem;
  color: #094024;
  background-color: rgba(0, 0, 0, 0.0);
  padding: 10px;
  cursor: pointer;
  z-index: 2;
  user-select: none;
  border-radius:30px;
`;

const ArrowLeft = styled(Arrow)`
  // left: 40%;
`;

const ArrowRight = styled(Arrow)`
  // right: 40%;
`;
